export default "__VITE_ASSET__BO1ZR138__"